import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHome\CreateFuneralHomeController::__invoke
* @see app/Http/Controllers/FuneralHome/CreateFuneralHomeController.php
* @route '/api/funeral-home'
*/
const CreateFuneralHomeController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateFuneralHomeController.url(options),
    method: 'post',
})

CreateFuneralHomeController.definition = {
    methods: ["post"],
    url: '/api/funeral-home',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\FuneralHome\CreateFuneralHomeController::__invoke
* @see app/Http/Controllers/FuneralHome/CreateFuneralHomeController.php
* @route '/api/funeral-home'
*/
CreateFuneralHomeController.url = (options?: RouteQueryOptions) => {
    return CreateFuneralHomeController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHome\CreateFuneralHomeController::__invoke
* @see app/Http/Controllers/FuneralHome/CreateFuneralHomeController.php
* @route '/api/funeral-home'
*/
CreateFuneralHomeController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateFuneralHomeController.url(options),
    method: 'post',
})

export default CreateFuneralHomeController